import nth from 'lodash/nth'
import {
  ALGOLIA_EVENT_INDEX_NAMES,
  useAlgoliaIndexNames,
} from '~/composables/algolia/useAlgoliaIndexNames'

export const useSearchOrderBy = () =>
  useState<string | null>('searchOrderBy', () => null)

export const useLocalizedOrderBy = () => {
  const { getEventListIndexName } = useAlgoliaIndexNames()
  const route = useRoute()
  const i18n = useI18n()

  const orderByOptions = ref([
    {
      label: i18n.t('general.pagination.orderByOptions.relevancy'),
      indexName: getEventListIndexName(null),
      // No typesenseSortBy here: relevancy's typesense sort_by is richer
      // than a static string (city + availability tiering, falling back to
      // distance or text match without a location) — see getTypesenseRelevancySortBy,
      // used directly in FilteredProductShowcase.vue.
      slug: 'relevancy',
      icon: 'clipboard-data',
    },
    {
      label: i18n.t('general.pagination.orderByOptions.newest'),
      indexName: getEventListIndexName(
        ALGOLIA_EVENT_INDEX_NAMES.sortByCreatedAtDesc
      ),
      typesenseSortBy: 'created_at:desc',
      typesensePreset: 'sort-newest',
      slug: 'newest',
      icon: 'calendar2-fill',
    },
    {
      label: i18n.t('general.pagination.orderByOptions.priceAsc'),
      indexName: getEventListIndexName(
        ALGOLIA_EVENT_INDEX_NAMES.sortByPriceAsc
      ),
      typesenseSortBy: 'default_price.amount:asc',
      typesensePreset: 'sort-price-asc',
      slug: 'price-asc',
      icon: 'piggy-bank-fill',
    },
  ])
  const currentOrderBy = computed(() => {
    return (
      orderByOptions.value.find((d) => d.slug === route.query?.orderBy) ||
      nth(orderByOptions.value, 0)
    )
  })
  const currentPage = computed(() => {
    return parseInt(route.query?.page?.toString() + '', 10) || 1
  })
  return {
    orderByOptions,
    currentOrderBy,
    currentPage,
  }
}
